module.exports = __webpack_public_path__ + "static/media/st.b1131044.jpg";